var map = {
	"./index_partner_0.png": 3181,
	"./index_partner_1.png": 1566,
	"./index_partner_10.png": 3547,
	"./index_partner_11.png": 6175,
	"./index_partner_12.png": 3919,
	"./index_partner_13.png": 4065,
	"./index_partner_14.png": 1391,
	"./index_partner_2.png": 5221,
	"./index_partner_3.png": 9063,
	"./index_partner_4.png": 160,
	"./index_partner_5.png": 7428,
	"./index_partner_6.png": 2142,
	"./index_partner_7.png": 8270,
	"./index_partner_8.png": 3845,
	"./index_partner_9.png": 4277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4761;